export const MIN_WIDTH_835 = '(min-width: 835px)';
export const MAX_WIDTH_834 = '(max-width: 834px)';